import { Injectable, OnInit } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './../providers/authentication.service';
import { UserProfileModel } from './../models/userprofile/user-profile.model';
import { UtilityService } from './../providers/utility.service';
import { CMS_PERM } from './../config';


@Injectable()
export class MultiStubIdProfileGuard implements CanActivate {
  loginSwitch: boolean = false;
  cmsUser: boolean = false;
  upgradeUser: boolean = false;
  noPermission: boolean = false;

  permission: any;

  id: any;
  rkey='';
  constructor(private router: Router, private authenticationService: AuthenticationService,
    private service: UtilityService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
if (location.href.indexOf('selectstubid') != -1 && (state.url == '/home' || state.url == '/learn/products' || state.url == '/learn/androidzerotouch' || state.url == '/learn/5g'|| state.url == '/learn/applebusinessmanager'|| state.url == '/learn/samsungknoxmobile' || state.url == '/manageInventory')) {
    alert('Please select a StubID to proceed.');
    return false;
} else {
    return true;
}
}
}
